import { Button, Form, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { useQueries } from "react-query";
import { getDimensions, getMetrics } from "services/apiRequest";

export function PopUpAddGraphical(props) {

    const { metricId, dimensionId, addDataFields } = props;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [form] = Form.useForm();

    const [{ data: dataMetric }, { data: dataDimension }] = useQueries([
        {
            queryKey: ["dataMetric"],
            queryFn: () => getMetrics(metricId),
        },
        {
            queryKey: ["dataDimension"],
            queryFn: () => getDimensions(dimensionId),
        },
    ]);

    useEffect(() => {
        if (dataMetric && dataDimension) {
            form.setFieldValue("metric", dataMetric?.data[0].id);
            form.setFieldValue("dimension", null);
        }
    }, [dataMetric, dataDimension]);

    function handleOk() {

        const values = form.getFieldValue();
        addDataFields(values);
        setIsModalOpen(false);
    }

    function handleCancel() {
        setIsModalOpen(false);
    }

    return (
        <div>
            <Button
                type="primary"
                onClick={() => {
                    setIsModalOpen(true);
                }}
            >
                Thêm biểu đồ
            </Button>

            <Modal
                title="Chọn điều kiện biểu đồ"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                cancelButtonProps={{ hidden: true }}
            >
                <Form
                    form={form}
                >
                    <div className="flex gap-5 justify-center">
                        <div className="flex flex-col gap-2">
                            <div>
                                <b>Chọn Metrics</b>
                            </div>
                            <Form.Item
                                name="metric"
                            >
                                <Select
                                    style={{ width: '200px', maxWidth: '400px' }}
                                    // defaultValue={metrics?.[0]?.name}
                                    options={
                                        (dataMetric?.data || [])?.map((item) => {
                                            return { label: item.name, value: item.id };
                                        }) || []
                                    }
                                />
                            </Form.Item>
                        </div>

                        <div className="flex flex-col gap-2">
                            <div>
                                <b>Chọn Dimension</b>
                            </div>

                            <Form.Item
                                name="dimension"
                            >
                                <Select
                                    style={{ width: '200px', maxWidth: '400px' }}
                                    // defaultValue={'Tất cả'}
                                    options={[
                                        { label: 'Tất cả', value: null },
                                        ...(dataDimension?.data || [])
                                            ?.filter((item) => item.id != 1)
                                            .map((item) => {
                                                return { label: item.name, value: item.id };
                                            }),
                                    ]}
                                />
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        </div>
    )
}